<template>
  <div v-if="!this.$store.state.loadingSpinner">
    <form ref="buyersForm">

      <div class="grey-box-container">

        <h2>Buyers Requirements</h2>

        <fieldset>
          <label for="instructions">Instructions for buyers * <small>&mdash; describe what the buyer needs know about the registration process</small></label>
          <v-icon class="pointer" @click="showMarkdown1 = !showMarkdown1">{{ showMarkdown1 ? 'visibility_off' : 'visibility' }}</v-icon>
          <template v-if="!showMarkdown1">
            <textarea id="instructions" v-model="auctionMetadata.instructions" rows="7" required></textarea>
          </template>
          <template v-else>
            <div style="padding:0.5rem; border:1px solid #ccc; background: #ddd" class="list-bullets">
              <vue-markdown :source="auctionMetadata.instructions" />
            </div>
          </template>
        </fieldset>

        <fieldset>
          <label>Required uploads * <small>&mdash; indicate the required documents uploads to be eligible to bid</small></label>
          <div v-for="(doc, index) in buyerRequirementOptions" :key="doc.id">
            <!-- This if exclude "Other" document type from the list, it is used only from buyer file upload-->
            <div v-if="doc.id < 99">
              <input type="checkbox" v-model="buyerRequirements" :value="doc.id" :id="'br-' + index" />
              <label :for="'br-' + index" style="font-weight: 400">{{ doc.text }}</label>
            </div>
          </div>
        </fieldset>

      </div>

      <div class="grey-box-container">

        <h2>Personal Message</h2>

        <fieldset>
          <label for="messageToBuyer">Message * <small>&mdash; message displayed after buyer has submitted the registration</small></label>
          <v-icon class="pointer" @click="showMarkdown2 = !showMarkdown2">{{ showMarkdown2 ? 'visibility_off' : 'visibility' }}</v-icon>
          <template v-if="!showMarkdown2">
            <textarea id="messageToBuyer" v-model="auctionMetadata.messageToBuyer" rows="15" required></textarea>
          </template>
          <template v-else>
            <div style="padding:0.5rem; border:1px solid #ccc; background: #ddd" class="list-bullets">
              <vue-markdown :source="auctionMetadata.messageToBuyer" />
            </div>
          </template>
        </fieldset>

      </div>
    </form>

  </div>
</template>

<script>
  import VueMarkdown from 'vue-markdown'
  import FileBox from './elements/FileBox.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'CreateListingBuyers',
    components: {
      VueMarkdown,
      FileBox
    },
    data() {
      return {
        showMarkdown1: false,
        showMarkdown2: false,
        auction: {
          id: 0
        },
        auctionMetadata: {
          instructions: '',
          messageToBuyer: ''
        },
        buyerRequirements: [
        ],
        buyerRequirementOptions: []
      }
    },
    computed: {
      ...mapGetters([
        'isAuctionEdit'
      ])
    },
    watch: {
      auction: {
        deep: true,
        handler() {
          this.$store.commit('setDataToNewAuctionStorage', { auction: this.auction })
        }
      },
      auctionMetadata: {
        deep: true,
        handler() {
          this.$store.commit('setDataToNewAuctionStorage', { auctionMetadata: this.auctionMetadata })
        }
      },
      buyerRequirements() {
        this.$store.commit('setDataToNewAuctionStorage', { buyerRequirements: this.buyerRequirements })
      }
    },
    created() {

      this.$PfxBackendApi.getBuyerRequirementsOptions().then(res => {
        // console.log('getBuyerRequirementsOptions res', res)
        res.data.forEach(document => {
          let item = { text: document.name, id: document.id }
          this.buyerRequirementOptions.push(item)
        })
        console.log('getBuyerRequirementsOptions Array: ', this.buyerRequirementOptions)
      }).catch(err => {
        console.error('getBuyerRequirementsOptions err', err)
      })

      Object.assign(this.auction, this.$store.state.newAuctionStorage.auction)
      Object.assign(this.auctionMetadata, this.$store.state.newAuctionStorage.auctionMetadata)
      Object.assign(this.buyerRequirements, this.$store.state.newAuctionStorage.buyerRequirements)

      if (!this.auctionMetadata.instructions) {
        this.auctionMetadata.instructions = 'You need to provide the required upload documents prior to be accepted into the auction.'
      }
      if (!this.auctionMetadata.messageToBuyer) {
        this.auctionMetadata.messageToBuyer = 'Hello!\n\n' +
          'I appreciate your interest in this auction.\n\n' +
          'I will review the documents and process your registration as soon as possible. ' +
          'If you have any questions at all regarding this property or the auction process, please contact me at any time. ' +
          'I look forward to your participation in the auction and wish you good luck!'
      }

      this.$store.commit('setDataToNewAuctionStorage', { auction: this.auction })
      this.$store.commit('setDataToNewAuctionStorage', { auctionMetadata: this.auctionMetadata })
      this.$store.commit('setDataToNewAuctionStorage', { buyerRequirements: this.buyerRequirements })
      this.$store.commit('setDataToNewAuctionStorage', { buyerRequirementOptions: this.buyerRequirementOptions })
    },
    methods: {
      beforeNextStep() {
        document.getElementById('br-0').setCustomValidity('')
        if (this.buyerRequirements.length === 0) {
          document.getElementById('br-0').setCustomValidity('Please fill out this field.')
        }

        if (!this.$refs.buyersForm.checkValidity()) {
          console.log('buyersForm.checkValidity failed')
          this.$refs.buyersForm.reportValidity()
          return false
        }

        return true
      }
    }
  }
</script>

<style lang="scss">

  label {
    font-weight: 600;
  }

</style>



// WEBPACK FOOTER //
// src/components/CreateListingBuyers.vue